import React from 'react'

import "./trade.css"
import {ReactComponent as Handshake} from '../assets/icons/handshake.svg'
import Button from "../Util/Button"
import Logo from "../Util/Logo"

const Trade = () => {
    return ( 
        <div id='trade'>

            <div className='img'>
                <img src='./images/purchase.webp' alt='' loading='eager' decoding='async' />
                <span className='overlay'/>
            </div>

            <section className='start'>
                <div className='text'>
                    <div className='logo'>
                        <img src="./images/logo3.svg" alt="" decoding='async' />
                        <p>SINIS</p>
                    </div>
                    <h1>
                        国际贸易
                    </h1>
                    <p>
                        德国与中国商品进出口贸易及相关服务
                    </p>
                </div>

                
            </section>

            <section className='overview'>
                <div className='text'>
                    <Handshake/>
                    <h2> 提供全面的进出口贸易服务，<br/>助力德国与中国企业在商品交换和全球市场拓展中实现增长。</h2>
                </div>

                <div className='wrapper'>

                    <div className='article'>
                        <p className='num'>01</p>
                        <h3 className='heading'>一般进出口贸易</h3>
                        <p>商品进出口：协助企业完成商品的采购、销售及运输<br/>
                        进出口清关：提供清关服务，确保符合两国法律规定</p>
                    </div>

                    <div className='article'>
                        <p className='num'>02</p>
                        <h3 className='heading'>德国产品销售代理</h3>
                        <p>销售代理：协助德国企业在中国销售产品，提供市场调研与渠道支持。<br/>
                         品牌推广：通过多渠道推广提升德国产品在中国的知名度与市场份额。</p>
                    </div>

                    <div className='article'>
                        <p className='num'>03</p>
                        <h3 className='heading'>海外采购代理</h3>
                        <p>采购代理：为中国企业在德国及其他国家处理采购、物流等流程 
                        货物接收与监装：确保货物在德国的接收、检查及安全运输 <br/>
                        国际运输管理：协助国际订舱与物流，确保准时交付</p>
                    </div>

                    <div className='article'>
                        <p className='num'>04</p>
                        <h3 className='heading'>中国产品销售代理</h3>
                        <p> 销售代理：协助中国企业在德国销售产品，提供市场调研与渠道支持。<br/>
                         品牌推广：通过多渠道推广提升中国产品在德国的知名度与市场份额。</p>
                    </div>

                </div>

            </section>

            <section className='promise'>

                <div className='img-wrapper'>
                    <img src='./images/munich.webp' alt='' loading='lazy' decoding='async' />
                    <div className='overlay'></div>
                </div>

                <div className='wrapper'>
                    <Logo/>

                    <p className='txt'>
                        醒狮中德商联主要业务之一是国际贸易。公司拥有德国海关总署批准的进出口经营权，专注于中德商品的进出口及德国产品在中国的销售代理。<br/>
                        自2002年成立以来，醒狮中德商联一直专注于进出口领域，涵盖太阳能光伏产品、汽车和日用商品等多个行业。公司拥有精通中文、德语和英语的专业人才，这些人才不仅具备扎实的专业知识，还拥有丰富的行业经验，为中德商家提供便捷、快速和安全的采购、翻译、质检、进出口、仓储和配送等一站式服务。<br/>
                        主要业务包括：<br/>
                        <span/>德国和中国商品的一般进出口贸易 <br/>
                        <span/>国际采购及国际销售 <br/>
                        <span/>代理采购海外货源、德国接货监装、国际订舱及进出口清关 <br/>
                        <span/>德国产品在中国的销售代理 <br/>
                        欢迎咨询，我们提供专业的进出口贸易及代理服务，助力您的跨国业务发展！<br/>
                    </p> 

                    <Button to="/contact" >联系我们</Button>
                </div>     
                
            </section>
        </div>
     );
}
 
export default Trade;